import React, { Component } from 'react';

export default class Answer extends Component {
    handleClick = () => {
        this.props.onAnswerClick(this.props.answer);
    };

    render() {
        var className = "Answer answer-" + this.props.identifier;
        return (
            <div className={className} onClick={this.handleClick}>
                <div>
                    <div className="answer-index">{this.props.indexLetter}</div>
                    <div className="answer-text" dangerouslySetInnerHTML={{__html: this.props.answer.text}} />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Answer.js